// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cocx","col":"styles_col__bNOSs"};